import smbService from './sessionInterceptor';


export const postEmailToNewsletterList = (email) => {
  return smbService.post(`/mail/subscribe`, {
    email
  });
};
